import { zodResolver } from '@hookform/resolvers/zod';
import { Box, Divider, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select, TextField, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { Loadin } from '../../../shared';
import { RISR } from '../../../../services/api/reports/ReportsServicesRisr';
// ... outras importações
import { Controller } from 'react-hook-form';

const dateString = z.string().refine((value) => {
    const date = new Date(value);
    return !isNaN(date.getTime());
}, {
    message: 'Data é obrigatório',
});

const GeneralSchema = z.object({
    periodo_referencia: dateString,
    empresa_executora: z.string().min(2, {message: 'Empresa é obrigatório' }),
    data_inspecao: dateString,
    data_dce: dateString,
    status_dce: z.string().min(2, {message: 'Status é obrigatório' }),
    responsavel: z.string().min(2, {message: 'Responsavel é obrigatório' }),
    art: z.string().min(2, {message: 'ART é obrigatório' }),
    orgao: z.string().min(2, {message: 'Orgão regulador é obrigatório' }),
    dpa: z.string().min(2, {message: 'DPA é obrigatório' }),
    cri: z.string().min(2, {message: 'CRI é obrigatório' }),
    classificacao: z.string().min(1, {message: 'Classificação é obrigatório' }),
    npgb: z.string().min(2, {message: 'O NPGB é obrigatório'})
});

interface IRegisterRisr {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onSubmit: (data: any) => void;
    setSubmitCallback: (callback: () => void) => void;
    data: RISR
}

export const GeneralRisr: React.FC<IRegisterRisr> = ({ onSubmit, setSubmitCallback, data }) => {    

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    const { register, handleSubmit, formState: { errors }, reset, control } = useForm({
        resolver: zodResolver(GeneralSchema),
        defaultValues: {
            periodo_referencia: '',
            empresa_executora: '',
            data_inspecao: '',
            data_dce: '',
            status_dce: '',
            responsavel: '',
            art: '',
            orgao: '',
            dpa: '',
            cri: '',
            classificacao: '',
            npgb: ''
        }
    });

    useEffect(() => {
        if (data) {
            reset({
                periodo_referencia: data.periodo_referencia ? new Date(data.periodo_referencia).toISOString().substring(0, 10) : '',
                empresa_executora: data.empresa_executora ?? '',
                data_inspecao: data.data_inspecao ? new Date(data.data_inspecao).toISOString().substring(0, 10) : '',
                data_dce: data.data_dce ? new Date(data.data_dce).toISOString().substring(0, 10) : '',
                status_dce: data.status_dce ?? '',
                responsavel: data.responsavel ?? '',
                art: data.art ?? '',
                orgao: data.orgao ?? '',
                dpa: data.dpa ?? '',
                cri: data.cri ?? '',
                classificacao: data.classificacao ?? '',
                npgb: data.npgb ?? ''
            });
        }
    }, [data, reset]);

    useEffect(() => {
        const submitHandler = handleSubmit(onSubmit);
        setSubmitCallback(() => {
            submitHandler();
        });
    }, [handleSubmit, onSubmit, setSubmitCallback]);

    if (!data) {
        return (
            <Box>
                <Loadin />
            </Box>
        );
    }

    return (
        <form>
            <Box>
                <Grid container marginBottom={2}>
                    <Grid item xs={12}>
                        <Typography variant='h5'>Geral</Typography>
                        <Divider />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            label='Período de referência'
                            id='periodo_referencia'
                            fullWidth
                            {...register('periodo_referencia')}
                            error={!!errors.periodo_referencia}
                            helperText={errors.periodo_referencia?.message}
                            type='date'
                            InputLabelProps={{
                                shrink: true,
                            }}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Empresa executora'
                            id='empresa_executora'
                            fullWidth
                            {...register('empresa_executora')}
                            error={!!errors.empresa_executora}
                            helperText={(errors.empresa_executora ? errors.empresa_executora.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Data da inspeção'
                            id='data_inspecao'
                            fullWidth
                            type='date'
                            {...register('data_inspecao')}
                            error={!!errors.data_inspecao}
                            helperText={(errors.data_inspecao ? errors.data_inspecao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Data de DCE/EISR'
                            id='data_dce'
                            fullWidth
                            type='date'
                            // value={data?.data_dce}
                            {...register('data_dce')}
                            error={!!errors.data_dce}
                            helperText={(errors.data_dce ? errors.data_dce.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Status do protocolo (DCE/EISR)'
                            id='status_dce'
                            fullWidth
                            // value={data?.status_dce}
                            {...register('status_dce')}
                            error={!!errors.status_dce}
                            helperText={(errors.status_dce ? errors.status_dce.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Responsável técnico'
                            id='responsavel'
                            fullWidth
                            // value={data?.responsavel}
                            {...register('responsavel')}
                            error={!!errors.responsavel}
                            helperText={(errors.responsavel ? errors.responsavel.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='ART (número)'
                            id='responsavel'
                            fullWidth
                            // value={data?.art}
                            {...register('art')}
                            error={!!errors.art}
                            helperText={(errors.art ? errors.art.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Órgão fiscalizador'
                            id='responsavel'
                            fullWidth
                            // value={data?.orgao}
                            {...register('orgao')}
                            error={!!errors.orgao}
                            helperText={(errors.orgao ? errors.orgao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Dano Potencial Associado (DPA)'
                            id='responsavel'
                            fullWidth
                            // value={data?.dpa}
                            {...register('dpa')}
                            error={!!errors.dpa}
                            helperText={(errors.dpa ? errors.dpa.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Categoria de Risco (CRI)'
                            id='responsavel'
                            fullWidth
                            // value={data?.cri}
                            {...register('cri')}
                            error={!!errors.cri}
                            helperText={(errors.cri ? errors.cri.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                        <TextField
                            InputLabelProps={{ shrink: true }}
                            label='Classificação (conforme órgão fiscalizador)'
                            id='responsavel'
                            fullWidth
                            // value={data?.classificacao}
                            {...register('classificacao')}
                            error={!!errors.classificacao}
                            helperText={(errors.classificacao ? errors.classificacao.message : '')?.toString()}
                            required
                        />
                    </Grid>
                    <Grid item xs={smDown ? 12 : 6}>
                    <FormControl fullWidth required error={!!errors.npgb}>
                        <InputLabel id="npgb-select-label">Nível de Perigo Global da Barragem(NPGB)</InputLabel>
                        <Controller
                            name="npgb"
                            control={control}
                            render={({ field }) => (
                                <Select
                                    labelId="npgb-select-label"
                                    label="Nível de Perigo Global da Barragem (NPGB)"
                                    {...field}
                                >
                                    <MenuItem value="Normal">Normal</MenuItem>
                                    <MenuItem value="Atenção">Atenção</MenuItem>
                                    <MenuItem value="Alerta">Alerta</MenuItem>
                                    <MenuItem value="Emergência">Emergência</MenuItem>
                                </Select>
                            )}
                        />
                        <FormHelperText>{errors.npgb?.message}</FormHelperText>
                    </FormControl>
                </Grid>
                </Grid>
            </Box>
        </form>
        
    );
};
